import HeadingMigration from "../../../../../../packages/design-system/heading/examples/constellation/heading-migration";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHheading_migration from "!!raw-loader!../../../../../../packages/design-system/heading/examples/constellation/heading-migration";
import * as React from 'react';
export default {
  HeadingMigration,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHheading_migration,
  React
};